export default "__VITE_ASSET__BWX_sMU___"